module.exports = __webpack_public_path__ + "static/media/cd.7c0fb930.svg";